import React, { Component } from 'react'

import ContactFormContainer from "../form/ContactFormContainer"
import ContactDetailsContainer from "./ContactDetailsContainer";
import SlidePaneView from '../../SlidePaneView';
import { Row, Col } from "react-bootstrap";
import Transition from "react-transition-group/Transition";
import _ from 'lodash';

import cx from 'classnames';
import styles from './styles.module.scss';
import Slider from 'src/components/slider';

class ContactDetailsSlideView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contactFormView: false,
    };

    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this.renderContactForm = this.renderContactForm.bind(this);
    this._handleCloseClick = this._handleCloseClick.bind(this);

  }

  _handleCloseClick() {
    this.props.onClose();

    this.setState({
      contactFormView: false
    });
  }

  _handleUpdateClick() {
    this.setState({
      contactFormView: true,
    });
  }

  _handleCancelClick() {
    this.setState({
      contactFormView: false,
    });
  }


  renderContactForm() {
    return (
      <Transition in={this.state.contactFormView} timeout={0}>
        {(state) => {
          return (
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={cx(styles.contactFormContainer, styles[state])}
            >
              <ContactFormContainer
                location={this.props.location}
                store={this.context.store}
                contact={this.props.selectedContact}
                onCancelClick={this._handleCancelClick}
                isResetView={this.state.resetView}
                contactList={ _.get(this.props,"contactList","")}
              />
            </Col>
          );
        }}
      </Transition>
    );
  }

  render() {
    return (
      <div>
      <Slider.Dialog width='640px' show={this.props.selectedContact != null}>
      <div className={styles.contactsContent}>
              <div>
            <Slider.Header className={styles.header}>

            <i className="paperflite-close" 
              onClick={this._handleCloseClick}
            
            style={{float:"right"}}/>
            </Slider.Header>
              </div>
            {
              this.props.selectedContact &&
              <ContactDetailsContainer
                id={this.props.selectedContact.id}
                contactList={this.props.contactList ? this.props.contactList : ""}
                sliderView={true}
                onUpdateClicked={this._handleUpdateClick}
                contactFormView={this.state.contactFormView}
                smallTalkPresence={this.props.smallTalkPresence}
                recipients={this.props.recipients}
                onClose={() => this.props.onClose()}
                canDelete={this.props.canDelete}
              />
            }
            {this.state.contactFormView && this.renderContactForm()}
          </div>
      </Slider.Dialog>
        
      </div>
    )
  }
}

export default ContactDetailsSlideView;
